<div class="container-fluid about">
    <div class="row d-flex align-items-center px-5 mx-5">
        <div class="col-lg-6 col-sm-12 pr-5">
            <h2>About Beyondi</h2>
            <div class="justify-content-around">
                <p>
                    The Beyondi Crowdsale mission is to empower project
                    developers with a decentralized initial dex offering
                    platform and incubation services on the Cronos Network that
                    exemplifies security and anti-whale system mechanics to
                    protect investors and therefore ensure project stability
                    throughout its life cycle.
                </p>
                <br />
                <p>
                    One of our main goals is to provide access for every
                    investor in the space, no matter what experience, with high
                    quality curated projects that are backed by passionate
                    hardworking professionals that will deliver on their
                    promises.
                </p>
            </div>
        </div>
        <div class="col-sm-12 col-lg-6 text-center">
            <img
                width="400px"
                class="img-responsive img-fluid lbLogo"
                src="../../assets/images/beyondi-token-logo.svg"
                style="z-index: 999999"
            />
        </div>
    </div>

    <div class="partnersBackground">
        <div class="row d-flex justify-content-center pt-5 mt-5">
            <h1 class="py-5">Partners</h1>
        </div>

        <div class="row d-flex justify-content-between mb-5">
            <div class="col-md-12 col-sm-12">
                <div class="row mb-5">
                    <div class="col-md-6 col-sm-12 text-center">
                        <p id="infodom-logo">INFODOM</p>
                    </div>
                    <div class="col-md-6 col-sm-12 text-center">
                        <p id="blokbe-logo">BlokBe</p>
                    </div>
                </div>
            </div>
            <div class="col-md-12 col-sm-12">
                <div class="row mb-5 pt-5">
                    <div class="col-md-4 col-sm-12 text-center">
                        <img
                            class="img-responsive img-fluid base58 img-partners"
                            src="../../assets/images/base58-logo-white.svg"
                        />
                    </div>
                    <div class="col-md-4 col-sm-12 text-center">
                        <img
                            src="../../assets/images/ale-logo.svg"
                            alt=""
                            class="img-responsive img-fluid img-partners"
                        />
                    </div>
                    <div class="col-md-4 col-sm-12 text-center">
                        <img
                            src="../../assets/images/blatform-logo.png"
                            alt=""
                            class="img-responsive img-fluid img-partners"
                        />
                    </div>
                </div>
                <div class="row mb-5 pt-5">
                    <div class="col-md-4 col-sm-12 text-center">
                        <img
                            src="../../assets/images/brodus-logo.svg"
                            alt=""
                            class="img-responsive img-fluid img-partners"
                        />
                    </div>
                    <div class="col-md-4 col-sm-12 text-center">
                        <img
                            src="../../assets/images/coreledger-logo.svg"
                            alt=""
                            class="img-responsive img-fluid img-partners"
                        />
                    </div>
                    <div class="col-md-4 col-sm-12 text-center">
                        <img
                            src="../../assets/images/green-mining-dao-logo.png"
                            alt=""
                            class="img-responsive img-fluid img-partners"
                        />
                    </div>
                </div>
                <div class="row mb-5 pt-5">
                    <div class="col-md-4 col-sm-12 text-center">
                        <img
                            src="../../assets/images/logo-ivault.png"
                            alt=""
                            class="img-responsive img-fluid img-partners"
                        />
                    </div>
                    <div class="col-md-4 col-sm-12 text-center">
                        <img
                            src="../../assets/images/revuto-logo-new.png"
                            alt=""
                            class="img-responsive img-fluid img-partners revuto-logo"
                        />
                    </div>
                    <div class="col-md-4 col-sm-12 text-center">
                        <img
                            src="../../assets/images/sportyn-logo.svg"
                            alt=""
                            class="img-responsive img-fluid img-partners"
                        />
                    </div>
                </div>
                <div class="row mb-5 pt-5">
                    <div class="col-md-6 col-sm-12 text-center">
                        <img
                            src="../../assets/images/ubik-logo.png"
                            alt=""
                            class="img-responsive img-fluid img-partners"
                        />
                    </div>
                    <div class="col-md-6 col-sm-12 text-center">
                        <img
                            src="../../assets/images/white-bridge-logo.svg"
                            alt=""
                            class="img-responsive img-fluid img-partners"
                        />
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
